import { VehicleLadder } from '../components/forms/s3/VehicleLadder';
import { CollectionEditorPage } from './ContentEditorPage';

/** The vehicles collection with the ladder table and the side-by-side comparison above the editor (lurerun.html "Admin"). */
export function VehiclesPage() {
  return <CollectionEditorPage collection="vehicles" extra={<VehicleLadder />} />;
}
